<template>
    <div class="md-layout">
        <div class="md-layout-item md-small-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>tag</md-icon>
                    </div>
                    <h4 class="title">Add Shift</h4>
                </md-card-header>

                <form @submit.prevent="add">
                    <md-card-content>
                        <div class="text-right">
                            <md-button @click="goBack" class="md-primary md-dense">
                                Back to List
                            </md-button>
                        </div>

                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Name
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="shift.name" />
                                    <validation-error :errors="apiValidationErrors.name" />
                                </md-field>
                            </div>
                        </div>

                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Code
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="shift.code" />
                                    <validation-error :errors="apiValidationErrors.code" />
                                </md-field>
                            </div>
                        </div>

                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                start Time
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <vue-timepicker v-model="shift.start_time" format="HH:mm:ss"></vue-timepicker>
                                    <validation-error :errors="apiValidationErrors.start_time"  />
<!--                                    <validation-error :errors="apiValidationErrors.start_time" @change="changeHandlerTwo" />-->
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                              End Time
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <vue-timepicker v-model="shift.end_time" format="HH:mm:ss"></vue-timepicker>
                                    <validation-error :errors="apiValidationErrors.end_time" />
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Cross Day
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Select ...</label>
                                    <md-select v-model="shift.cross_day" name="cross_day">
                                        <md-option value=1>Yes</md-option>
                                        <md-option value=0>No</md-option>
                                    </md-select>
                                </md-field>
                                <validation-error :errors="apiValidationErrors.cross_day" />
                            </div>
                        </div>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Active Status
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Select ...</label>
                                    <md-select v-model="shift.is_active" name="is_active">
                                        <md-option value=1>Yes</md-option>
                                        <md-option value=0>No</md-option>
                                    </md-select>
                                </md-field>
                                <validation-error :errors="apiValidationErrors.is_active" />
                            </div>
                        </div>
                    </md-card-content>

                    <md-card-actions md-alignment="right">
                        <md-button type="submit" class="md-success">Add Shift</md-button>
                    </md-card-actions>
                </form>
            </md-card>
        </div>
    </div>
</template>
<script>
import { ValidationError } from '@/components';
import formMixin from '@/mixins/form-mixin';

export default {
    components: { ValidationError },

    mixins: [formMixin],

    data: () => ({
        shiftData:{},
        shift: {
            type:'shifts',
            name:null,
            code:null,
            start_time:null,
            end_time: null,
            cross_day: null,
        },
    }),
    methods: {
        async add () {


          try {
            this.shiftData = {
                type:'shifts',
                name:this.shift.name,
                code:this.shift.code,
                is_active:this.shift.is_active,
                start_time:this.shift.start_time.HH + ':' + this.shift.start_time.mm + ':' + this.shift.start_time.ss,
                end_time:this.shift.end_time.HH + ':' + this.shift.end_time.mm + ':' + this.shift.end_time.ss,
                cross_day: this.shift.cross_day,
            };
                await this.$store.dispatch('shifts/add',  this.shiftData);
                this.notifySuccess('Shift added successfully.');
                this.goBack();
            } catch (e) {
            console.error(e);
              this.notifyError(e);
                if (e.response.data.errors[0]) {
                    await this.notifyError(e.response.data.errors[0].title);
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.notifyError('Oops, something went wrong!');
                }
              this.notifyException(e);
            }
        },

        goBack () {
            this.$router.push({ name: 'Shifts List' });
        },

    },
};
</script>
